import React, { memo } from "react";
import { Grid, Skeleton } from "@mui/material";

function InlinePOGLoader() {
  return (
    <Grid
      container
      item
      xs
      alignItems="center"
      justifyContent="space-between"
      pl={0.5}
      pr={4}
    >
      <Grid item minWidth="1.563rem" sx={{ marginRight: "-26px" }}>
        <Skeleton
          variant="circular"
          width={15}
          height={15}
          sx={{ ml: "0.2rem", width: "100%" }}
        />
      </Grid>
      <Grid item md={1.8} lg={2.8} className="pog-title" mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "5rem",
          }}
        />
      </Grid>
      <Grid item minWidth="3.203rem" mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item minWidth="4.3rem" mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.8} mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "2rem",
          }}
        />
      </Grid>
      <Grid item md={0.4} lg={0.5} mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "2rem",
          }}
        />
      </Grid>
      <Grid item minWidth="2.693rem" mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.5} lg={0.8} mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "2rem",
          }}
        />
      </Grid>
      <Grid item md={0.9} lg={1} mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "2rem",
          }}
        />
      </Grid>
      <Grid item md={0.6} lg={0.9} mr={0.5}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "2rem",
          }}
        />
      </Grid>
      <Grid item md={0.9} lg={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
            minWidth: "2rem",
          }}
        />
      </Grid>
    </Grid>
  );
}

export default memo(InlinePOGLoader);
